import { render, staticRenderFns } from "./edit-hiresource.vue?vue&type=template&id=ec687674&scoped=true&"
import script from "./edit-hiresource.vue?vue&type=script&lang=ts&"
export * from "./edit-hiresource.vue?vue&type=script&lang=ts&"
import style0 from "./edit-hiresource.vue?vue&type=style&index=0&id=ec687674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec687674",
  null
  
)

export default component.exports